import React from 'react';
import PropTypes from 'prop-types';

export default function SendArrowIcon({ className = 'h-[18px] w-[18px]', strokeWidth = 1.6 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M5 12h14M13 6l6 6-6 6' />
    </svg>
  );
}

SendArrowIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};
